import { useState } from "react";
import { completarDatos } from "./authService";
import PantallaEntrada, { Alerta } from "./PantallaEntrada";

// Quien fue invitado solo con su correo escribe aquí sus nombres y su celular antes de entrar (una vez).
// El celular queda como teléfono y WhatsApp de su ficha.
function CompletarDatos({ usuario, onListo, onSalir }) {
  const [nombres, setNombres] = useState("");
  const [apellidos, setApellidos] = useState("");
  const [celular, setCelular] = useState("");
  const [error, setError] = useState("");
  const [guardando, setGuardando] = useState(false);

  const guardar = async (e) => {
    e?.preventDefault();
    if (!nombres.trim() || !apellidos.trim()) return setError("Escribe tus nombres y tus apellidos");
    if (!/^\+?[0-9]{7,15}$/.test(celular.replace(/[\s().-]/g, ""))) return setError("Escribe tu número de celular");
    setGuardando(true);
    setError("");
    try {
      onListo(await completarDatos(nombres.trim(), apellidos.trim(), celular.trim()));
    } catch (e) {
      setError(e.message);
      setGuardando(false);
    }
  };

  return (
    <PantallaEntrada>
      <form onSubmit={guardar} className="panel w-full max-w-sm p-8" noValidate>
        <h2 className="mb-2 text-lg font-black uppercase tracking-tight text-white">Tus datos</h2>
        <p className="mb-5 text-sm text-gray-400">
          Bienvenido a Mi Casa. Escribe tu nombre como quieres que aparezca en la iglesia y tu celular.
        </p>
        <label htmlFor="mis-nombres" className="etiqueta">Nombres</label>
        <input id="mis-nombres" value={nombres} onChange={(e) => setNombres(e.target.value)} className="campo mb-4"
          autoComplete="given-name" disabled={guardando} autoFocus />
        <label htmlFor="mis-apellidos" className="etiqueta">Apellidos</label>
        <input id="mis-apellidos" value={apellidos} onChange={(e) => setApellidos(e.target.value)} className="campo mb-4"
          autoComplete="family-name" disabled={guardando} />
        <label htmlFor="mi-celular" className="etiqueta">Celular</label>
        <input id="mi-celular" type="tel" inputMode="tel" value={celular} onChange={(e) => setCelular(e.target.value)}
          className="campo mb-5" autoComplete="tel" placeholder="300 123 4567" disabled={guardando} />
        {error && <Alerta>{error}</Alerta>}
        <button type="submit" disabled={guardando} className="btn-primario btn-lg w-full">
          {guardando ? "Guardando..." : "Entrar"}
        </button>
        <p className="mt-4 text-center text-xs text-gray-500">
          {usuario?.username} ·{" "}
          <button type="button" onClick={onSalir} className="underline hover:text-white">Salir</button>
        </p>
      </form>
    </PantallaEntrada>
  );
}

export default CompletarDatos;
